// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details-page {
  padding: 0;
  height: 100%;
}

.details-page .room-settings-section {
  margin-bottom: 32px;
}

.details-field {
  margin-bottom: 20px;
  padding: 0 16px;
}

.details-field-label {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #434343;
  margin-bottom: 6px;
}

.details-field-input {
  width: 100%;
  padding: 8px 12px;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 15px;
  color: #2D2D2D;
  border: 1px solid #CCCCCC;
  border-radius: 6px;
  outline: none;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.details-field-input:focus {
  border-color: #DE4858;
}

.details-field-input:disabled {
  background-color: #F5F5F5;
  color: #6A6A6A;
  cursor: not-allowed;
}

.details-field-input.has-error {
  border-color: #D32F2F;
}

.details-field-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
  min-height: 20px;
}

.details-field-counter {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 12px;
  color: #999999;
}

.details-field-counter.near-limit {
  color: #D32F2F;
}

.details-field-status {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 12px;
}

.details-field-saving {
  color: #6A6A6A;
}

.details-field-error {
  color: #D32F2F;
}

.details-field-spinner {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid #CCCCCC;
  border-top-color: #DE4858;
  border-radius: 50%;
  animation: details-spin 0.6s linear infinite;
}

@keyframes details-spin {
  to { transform: rotate(360deg); }
}

.details-field-value {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 15px;
  color: #2D2D2D;
  padding: 8px 12px;
}

.details-field-value--scrollable {
  overflow-x: auto;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/RoomSettings/DetailsPage.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gGAAgG;EAChG,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gGAAgG;EAChG,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".details-page {\n  padding: 0;\n  height: 100%;\n}\n\n.details-page .room-settings-section {\n  margin-bottom: 32px;\n}\n\n.details-field {\n  margin-bottom: 20px;\n  padding: 0 16px;\n}\n\n.details-field-label {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #434343;\n  margin-bottom: 6px;\n}\n\n.details-field-input {\n  width: 100%;\n  padding: 8px 12px;\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 15px;\n  color: #2D2D2D;\n  border: 1px solid #CCCCCC;\n  border-radius: 6px;\n  outline: none;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.details-field-input:focus {\n  border-color: #DE4858;\n}\n\n.details-field-input:disabled {\n  background-color: #F5F5F5;\n  color: #6A6A6A;\n  cursor: not-allowed;\n}\n\n.details-field-input.has-error {\n  border-color: #D32F2F;\n}\n\n.details-field-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 4px;\n  min-height: 20px;\n}\n\n.details-field-counter {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 12px;\n  color: #999999;\n}\n\n.details-field-counter.near-limit {\n  color: #D32F2F;\n}\n\n.details-field-status {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 12px;\n}\n\n.details-field-saving {\n  color: #6A6A6A;\n}\n\n.details-field-error {\n  color: #D32F2F;\n}\n\n.details-field-spinner {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border: 2px solid #CCCCCC;\n  border-top-color: #DE4858;\n  border-radius: 50%;\n  animation: details-spin 0.6s linear infinite;\n}\n\n@keyframes details-spin {\n  to { transform: rotate(360deg); }\n}\n\n.details-field-value {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 15px;\n  color: #2D2D2D;\n  padding: 8px 12px;\n}\n\n.details-field-value--scrollable {\n  overflow-x: auto;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
